import { Fragment, useState } from 'react';

import { useMe } from '@crehana/web/ReactContexts/AuthContext';

import AuthForm from '@/shared/components/AuthForm';
import type { AuthInnerFormProps } from '@/shared/components/AuthForm/types';
import Steps from '@/views/B2BCheckout/components/Steps';
import { ACTIONS } from '@/views/B2BCheckout/context/types';
import useCheckoutCtx from '@/views/B2BCheckout/hooks/useCheckoutCtx';

const RegisterForm = () => {
  const [currentForm, onChangeForm] = useState<'register' | 'login'>(
    'register',
  );
  const {
    dispatch,
    state: { currentStep },
    ONBOARDING_STEPS,
  } = useCheckoutCtx();
  const { refetch } = useMe();

  const onSuccess: AuthInnerFormProps['onCustomSuccess'] = async () => {
    const response = await refetch();

    if (response.data.me) {
      dispatch({
        type: ACTIONS.SET_ACCOUNT_DETAILS,
        payload: {
          firstName: response.data.me?.firstName || '',
          lastName: response.data.me?.lastName || '',
          email: response.data.me?.email || '',
          role: '',
          company: '',
          phoneNumber: {
            code: response.data.me?.phoneCode || '',
            phoneNumber: response.data.me?.phoneNumber || '',
          },
          country: undefined,
          docNroCompany: '',
        },
      });
      dispatch({
        type: ACTIONS.NAVIGATE,
        payload: 2,
      });
    }
  };

  return (
    <Fragment>
      <Steps
        currentStep={currentStep}
        steps={ONBOARDING_STEPS}
        className="mb-32 sm:mb-56"
      />
      <AuthForm
        currentForm={currentForm}
        onChangeForm={onChangeForm}
        onSuccess={onSuccess}
      />
    </Fragment>
  );
};

export default RegisterForm;
